import PropTypes from 'prop-types';

import {
  STYLING_GEL_CONSULTATION_QUESTION_SET_KEY,
  SUPPLEMENTS_CONSULTATION_QUESTION_SET_KEY,
} from 'Apps/Consultation/constants';

const consultationSubsetCategoryProp = PropTypes.oneOf([
  STYLING_GEL_CONSULTATION_QUESTION_SET_KEY,
  SUPPLEMENTS_CONSULTATION_QUESTION_SET_KEY,
]);

export default consultationSubsetCategoryProp;
